import React from "react";
import "./DesignSystemContent.css";

// Importa tus imágenes aquí
import matrixImg from "../../../assets/projects/DesignSystem/color-matrix.png";

import beforeImg from "../../../assets/projects/DesignSystem/before.png";
import afterImg from "../../../assets/projects/DesignSystem/after.png";
import roadMap from "../../../assets/projects/DesignSystem/roadmap.png";
import illustration1 from "../../../assets/projects/DesignSystem/illustration1.png";
import illustration2 from "../../../assets/projects/DesignSystem/illustration2.png";
import illustration3 from "../../../assets/projects/DesignSystem/illustration3.png";
import gifExample from "../../../assets/projects/DesignSystem/example.gif";
import ImgFinal_1 from "../../../assets/projects/DesignSystem/ImgFinal_1.png";
import ImgFinal_2 from "../../../assets/projects/DesignSystem/ImgFinal_2.png";
import ImgFinal_3 from "../../../assets/projects/DesignSystem/ImgFinal_3.png";
import ImgFinal_4 from "../../../assets/projects/DesignSystem/ImgFinal_4.png";
import iconConsistency from "../../../assets/projects/DesignSystem/iconConsistency.png"
import iconLegality from   "../../../assets/projects/DesignSystem/iconLegality.png"
import iconReduction from "../../../assets/projects/DesignSystem/iconReduction.png"
import atomicDesign from "../../../assets/projects/DesignSystem/atomicDesign.png"
import CardSortingImg from "../../../assets/projects/DesignSystem/cardSorting.png";
import TreeTestingImg from "../../../assets/projects/DesignSystem/treeTesting.png";
import SurveysImg from "../../../assets/projects/DesignSystem/surveys.png";


export default function DesignSystemContent() {
  return (
    <div className="ds-content">
      {/* Intro Text */}
      <div className="ds-intro">
        <p>
          Todo1, now called Iuvity, provides financial solutions to lead banks in Latin America and the United States.
        </p>
      </div>

      {/* Description */}
      <div className="ds-description">
        <p>
        Kymabank was one of the company’s flagship products, a web and mobile banking platform offered to financial institutions. When I joined the team after finishing my internship, I realized that all guidelines and component usage knowledge were held by a single designer, who was about to leave the company. This created bottlenecks,<span className="ds-highlight-green">increased time spent answering questions, led to design inconsistencies and unnecessary rework. </span>Furthermore, all designers identified several accessibility issues across the product.
        </p>
      </div>

      {/* Main Question */}
      <h1 className="ds-question">
        How might we reduce design time and create a product that is accessible to everyone, enabling better design practices and outcomes?
      </h1>

      {/* Quote Box */}
      <div className="ds-quote-box">
        <p>
          Creating a design system that could update automatically for all designers and using this opportunity to <span className="ds-highlight-dark">redesign the entire ui aiming for better accessibility.</span> This was the most impactful solution.
        </p>
      </div>

      {/* Additional Description */}
      <div className="ds-text-block">
        <p>
          Nevertheless, this solution required additional time and effort beyond the design team’s planned activities, and the company did not intend to hire new designers. Furthermore, redesigning the product would introduce changes that could affect both the Marketing and Development teams.
        </p>
      </div>

      {/* Convince Section */}
      <section className="ds-section">
        <h2 className="ds-section-title">
          How could I convince our manager and stakeholders that it was worth the investment?
        </h2>
        <p className="ds-text">With evidences and talking in business language.</p>

        <div className="ds-convince-layout">
          {/* Left - Analyzing Card */}
          <div className="ds-analyzing-card">
            <h3>Analyzing the actual state</h3>
            <p>
              I started by analyzing the current color palette using a matrix to determine whether it met the minimum contrast requirements for users with visual impairments.
            </p>
   
          </div>

          {/* Right - Image */}
          <div className="ds-analyzing-image">
            <img src={matrixImg} alt="Color accessibility analysis" />
          </div>
        </div>
      </section>

      {/* Information Architecture Section */}
      <section className="ds-section">
        <h2 className="ds-section-title">I analyzed the Information Architecture</h2>
        <p className="ds-text">
          With the goal of understanding the user's mental model and creating a proposal that addressed their needs, ultimately improving their navigation experience. I applied the next methodologies:
        </p>

        {/* Timeline/Flow Diagram */}
        <div className="ds-timeline">
        
          <div className="ds-timeline-items">
            <div className="ds-timeline-item">
              <img src={CardSortingImg} alt="Card sorting" />
              <h3>Card sorting</h3>
              <p>It allowed me to observe how users categorize the menu functionalities.</p>
            </div>
            <div className="ds-timeline-item">
              <img src={TreeTestingImg} alt="Tree testing" />
              <h3>Tree testing</h3>
              <p>It allowed me to evaluate the menu hierarchy by seeing whether users could find the specific category that helps them complete a given task.</p>
            </div>
            <div className="ds-timeline-item">
              <img src={SurveysImg} alt="Surveys" />
              <h3>Surveys</h3>
              <p>I asked a series of questions related to the naming of the functionalities.</p>
            </div>
          </div>
        </div>

        {/* Conclusion Box */}
        <div className="ds-conclusion-box">
          <h4>Conclusions:</h4>
          <p>
            Some functionalities had a 100% failure rate in findability. Additionally, with new features soon to be added within a specific category, it became necessary to reorganize the existing functionalities to ensure alignment with the purpose of each section. Lastly, some categories could be merged with existing ones, and several features needed to be renamed because their labels were unclear to users.
          </p>
        </div>
      </section>

      {/* Before Section */}
      <section className="ds-section">
        <h3 className="ds-label">Before:</h3>
        <div className="ds-before-image">
          <img src={beforeImg} alt="Before redesign" />
        </div>
      </section>

      {/* After Section */}
      <section className="ds-section">
        <h3 className="ds-label">After:</h3>
        <div className="ds-after-image">
          <img src={afterImg} alt="After redesign" />
        </div>
      </section>

      {/* Results Description */}
      <div className="ds-text-block">
        <p>
          So, I created a report on the findings, highlighting the benefits for both the design team and the business objectives.
        </p>
      </div>

      {/* Benefits Cards - Blue Section */}
      <div className="ds-benefits-section">
        <div className="ds-benefits-grid">
          <div className="ds-benefit-card">
            <div className="ds-benefit-icon"><img src={iconReduction} alt="" /></div>
            <h3>Time reduction</h3>
            <p>Building a design system could reduce design time by up to 50% by minimizing consultations and validation cycles..</p>
          </div>
          <div className="ds-benefit-card">
            <div className="ds-benefit-icon"><img src={iconLegality} alt="" /></div>
            <h3>Accessibility</h3>
            <p>The company was interested in expanding the product to new markets. I showed the team that, due to legal requirements, we needed to meet certain minimum web accessibility standards.</p>
          </div>
          <div className="ds-benefit-card">
            <div className="ds-benefit-icon"><img src={iconConsistency} alt="" /></div>
            <h3>Consistency </h3>
            <p>Maintain visual consistency across screens and ensure that the product is accessible to everyone.</p>
          </div>
        </div>
      </div>

      {/* Y aceptaron */}
      <section className="ds-section">
        <h2 className="ds-section-title">The team agreed and I was assigned to continue working on this initiative...</h2>
        <p>Throughout the accessibility work, I learned that accessibility is not just a design task. It requires developers to build accessible experiences at the code level, since many users rely on assistive technologies to navigate our application. This made it clear that accessibility must be considered jointly by designers and developers throughout the entire product development process.</p>
      </section>

      {/* Roadmap Section */}
      <section className="ds-section">
      
        
        <div className="ds-roadmap">
            <div className="ds-roadmap-item-text">
                <h3 className="ds-roadmap-title">Roadmap</h3>
                <p className="ds-roadmap-text">Together, with the business and development teams, we prioritized the accessibility improvements needed to ensure our website and mobile app aligned with WCAG 3.0 standards.</p>
            </div>
            <div className="ds-roadmap-item-img">
                <img src={roadMap} alt="" />
            </div>

 
      
        </div>

     <p>Applying atomic design, I started constructing the components for the design system.</p>

      <img src={atomicDesign} alt="" />
  
      </section>



      {/* Ilustraciones Section */}
      <section className="ds-section">
        <h2 className="ds-section-title">After building the core components, I also designed new illustrations and animations…</h2>
        

        <p>I used my prior experience as an animator and illustrator to create fresh icons, micro-illustrations, and micro-animations. I wanted to give the application a renewed visual feel, especially since the previous version lacked these elements. I believe there’s always room to invest in small details that elevate the overall user experience.</p>
        <div className="ds-illustrations-grid">
          <div className="ds-illustration-item">
            <img src={illustration1 }alt="Illustration 1" />
          </div>
          <div className="ds-illustration-item">
            <img src={illustration2 }alt="Illustration 2" />
          </div>
          <div className="ds-illustration-item">
            <img src={illustration3 }alt="Illustration 3" />
          </div>
        </div>
      </section>
 <section className="ds-section">   

<div className="gif-section">
    <img src={gifExample} alt="" />
</div>
 </section>
      {/* Rediseño aplicado */}
      <section className="ds-section">
        <h2 className="ds-section-title">Finally, I redesigned some mockups using the new design system to help visualize how they look...</h2>
        <p>I took the opportunity to make improvements and add new features based on user interviews. Additionally, I reviewed previous backlogs to apply the improvements to the new design.</p>
        
        <div className="ds-redesign-gallery">
          <div className="ds-redesign-item">
            <img src={ImgFinal_1} alt="Redesign 1" />
          </div>
          <div className="ds-redesign-item">
            <img src={ImgFinal_2} alt="Redesign 2" />
          </div>
          <div className="ds-redesign-item">
            <img src={ImgFinal_3} alt="Redesign 3" />
          </div>
          <div className="ds-redesign-item">
            <img src={ImgFinal_4} alt="Redesign 4" />
          </div>
        </div>


          <p>This activity didn’t end there. I created shared libraries and documentation with principles and guidelines for both designers and developers. I also produced materials such as tutorials on how to install and use the library, and I facilitated dedicated sessions to answer questions and provide ongoing support.

<br></br>
<br></br>
Building a design system goes far beyond a visual redesign, it requires continuous guidance, collaboration, and a committed team. But the benefits are clear: we significantly reduced design and development consultations, improved onboarding for new designers, and, most importantly, delivered a more accessible product for everyone.</p>
      </section>
    </div>
  );
}